import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {ImageUrlManager} from "@biletix/core/common/helper/image-url-manager";
import {environment} from "@biletix/env";

@Pipe({
  name: 'image',
  standalone: false
})
export class ImagePipe implements PipeTransform {


  constructor(private sanitizer: DomSanitizer) {
  }

  transform(url: string, basePath: string = environment.eventImageBasePath, noImagePath: string = 'noimage.gif'): SafeUrl |string{
      return ImageUrlManager.create(url,basePath,noImagePath);
  

  }

}
